export default __webpack_public_path__ + "static/media/footer.028f26cf.png";